import withReducer from '../../store/withReducer'
import AddNewPatient from './container'
import reducer from './module'

export default withReducer('addNewPatient', reducer)(AddNewPatient)



// WEBPACK FOOTER //
// ./src/legacy/pages/AddNewPatient/index.js